<template>
  <div class="presence-page">
    <!-- Hero Section -->
    <section class="presence-hero position-relative">
      <div class="hero-bg" style="background-image: url('/resource/banner-three.jpg')"></div>
      <div class="hero-overlay"></div>
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="hero-content text-center">
              <div class="hero-breadcrumb">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                      <router-link to="/">Home</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Our Presence</li>
                  </ol>
                </nav>
              </div>
              <div class="hero-title">
                <h1>Our Global Presence</h1>
              </div>
              <div class="hero-description">
                <p>Expanding our automotive services across multiple locations to serve customers worldwide with excellence and innovation.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Global Statistics Section -->
    <section class="global-stats-section position-relative see__pad">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-header text-center">
              <div class="section-tag">
                <i class="fas fa-globe"></i>
                <span>WORLDWIDE REACH</span>
              </div>
              <h2>Our Global Impact</h2>
              <p class="section-description">Serving customers across multiple continents with our comprehensive automotive solutions</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-6">
            <div class="stat-card text-center">
              <div class="stat-icon">
                <i class="fas fa-map-marker-alt"></i>
              </div>
              <div class="stat-number">25+</div>
              <div class="stat-label">Countries</div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="stat-card text-center">
              <div class="stat-icon">
                <i class="fas fa-city"></i>
              </div>
              <div class="stat-number">150+</div>
              <div class="stat-label">Cities</div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="stat-card text-center">
              <div class="stat-icon">
                <i class="fas fa-users"></i>
              </div>
              <div class="stat-number">500K+</div>
              <div class="stat-label">Customers Served</div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="stat-card text-center">
              <div class="stat-icon">
                <i class="fas fa-clock"></i>
              </div>
              <div class="stat-number">24/7</div>
              <div class="stat-label">Support</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Regional Operations Section -->
    <section class="regional-operations position-relative see__pad">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-header text-center">
              <div class="section-tag">
                <i class="fas fa-building"></i>
                <span>REGIONAL HUBS</span>
              </div>
              <h2>Regional Operations</h2>
              <p class="section-description">Strategic locations across the globe to provide localized automotive services</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <div class="region-card">
              <div class="region-image">
                <img src="@/assets/resource/portfolio-01.jpg" alt="Asia Pacific" />
              </div>
              <div class="region-content">
                <h3>Asia Pacific</h3>
                <p>Leading automotive services across Asia Pacific with state-of-the-art facilities and expert technicians.</p>
                <ul class="region-features">
                  <li><i class="fas fa-check"></i> 50+ Service Centers</li>
                  <li><i class="fas fa-check"></i> EV Specialization</li>
                  <li><i class="fas fa-check"></i> 24/7 Support</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="region-card">
              <div class="region-image">
                <img src="@/assets/resource/portfolio-02.jpg" alt="North America" />
              </div>
              <div class="region-content">
                <h3>North America</h3>
                <p>Comprehensive automotive solutions across North America with advanced diagnostic capabilities.</p>
                <ul class="region-features">
                  <li><i class="fas fa-check"></i> 75+ Service Centers</li>
                  <li><i class="fas fa-check"></i> Hybrid Expertise</li>
                  <li><i class="fas fa-check"></i> Mobile Services</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="region-card">
              <div class="region-image">
                <img src="@/assets/resource/portfolio-03.jpg" alt="Europe" />
              </div>
              <div class="region-content">
                <h3>Europe</h3>
                <p>Premium automotive services across Europe with focus on luxury and performance vehicles.</p>
                <ul class="region-features">
                  <li><i class="fas fa-check"></i> 40+ Service Centers</li>
                  <li><i class="fas fa-check"></i> Luxury Car Specialists</li>
                  <li><i class="fas fa-check"></i> Performance Tuning</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Service Centers Section -->
    <section class="service-centers position-relative see__pad">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-header text-center">
              <div class="section-tag">
                <i class="fas fa-tools"></i>
                <span>SERVICE NETWORK</span>
              </div>
              <h2>Our Service Centers</h2>
              <p class="section-description">Modern facilities equipped with cutting-edge technology and skilled professionals</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="service-type-card">
              <div class="service-icon">
                <i class="fas fa-car"></i>
              </div>
              <div class="service-content">
                <h3>Automotive Services</h3>
                <p>Complete range of automotive services including maintenance, repair, and diagnostics for all vehicle types.</p>
                <ul>
                  <li>Engine Diagnostics & Repair</li>
                  <li>Transmission Services</li>
                  <li>Brake System Maintenance</li>
                  <li>AC & Climate Control</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="service-type-card">
              <div class="service-icon">
                <i class="fas fa-bolt"></i>
              </div>
              <div class="service-content">
                <h3>Electric Vehicle Services</h3>
                <p>Specialized services for electric and hybrid vehicles with certified technicians and advanced equipment.</p>
                <ul>
                  <li>Battery Health Monitoring</li>
                  <li>Charging System Repair</li>
                  <li>Electric Motor Services</li>
                  <li>Software Updates</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Partnership Network Section -->
    <section class="partnership-network position-relative see__pad">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-header text-center">
              <div class="section-tag">
                <i class="fas fa-handshake"></i>
                <span>STRATEGIC PARTNERSHIPS</span>
              </div>
              <h2>Our Partnership Network</h2>
              <p class="section-description">Collaborating with industry leaders to provide the best automotive solutions</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <div class="partner-card text-center">
              <div class="partner-icon">
                <i class="fas fa-industry"></i>
              </div>
              <h4>Manufacturers</h4>
              <p>Authorized service partnerships with leading automotive manufacturers worldwide.</p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="partner-card text-center">
              <div class="partner-icon">
                <i class="fas fa-cogs"></i>
              </div>
              <h4>Technology Partners</h4>
              <p>Advanced diagnostic tools and software solutions from top technology providers.</p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="partner-card text-center">
              <div class="partner-icon">
                <i class="fas fa-shipping-fast"></i>
              </div>
              <h4>Logistics Partners</h4>
              <p>Efficient parts supply chain and logistics support for faster service delivery.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { onMounted } from 'vue'
import WOW from 'wowjs'

export default {
  name: 'PresencePage',
  setup() {
    onMounted(() => {
      new WOW.WOW({ mobile: false }).init()
    })
  }
}
</script>

<style scoped>
/* Hero Section */
.presence-hero {
  padding: 200px 0 120px;
  position: relative;
  overflow: hidden;
}

.hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.5) 100%);
}

.hero-content {
  position: relative;
  z-index: 2;
  color: #fff;
}

.hero-breadcrumb {
  margin-bottom: 30px;
}

.hero-breadcrumb .breadcrumb {
  background: transparent;
  padding: 0;
  margin: 0;
}

.hero-breadcrumb .breadcrumb-item a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
}

.hero-breadcrumb .breadcrumb-item.active {
  color: #F6EC4F;
}

.hero-title h1 {
  font-size: 60px;
  font-weight: 700;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.hero-description p {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.9);
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

/* Global Stats Section */
.global-stats-section {
  padding: 100px 0;
  background: #00061A;
  color: #fff;
}

.section-header {
  margin-bottom: 80px;
}

.section-tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(246, 236, 79, 0.1);
  border: 1px solid rgba(246, 236, 79, 0.3);
  padding: 8px 16px;
  border-radius: 25px;
  margin-bottom: 20px;
  font-size: 12px;
  font-weight: 600;
  color: #F6EC4F;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.section-header h2 {
  font-size: 48px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 20px 0;
  font-family: 'Archivo', sans-serif;
}

.section-description {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.8);
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.stat-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(246, 236, 79, 0.2);
  border-radius: 15px;
  padding: 40px 20px;
  margin-bottom: 30px;
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
  border-color: rgba(246, 236, 79, 0.4);
  box-shadow: 0 15px 40px rgba(246, 236, 79, 0.1);
}

.stat-icon {
  font-size: 48px;
  color: #F6EC4F;
  margin-bottom: 20px;
}

.stat-number {
  font-size: 48px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 10px;
  font-family: 'Archivo', sans-serif;
}

.stat-label {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 600;
}

/* Regional Operations */
.regional-operations {
  padding: 100px 0;
  background: linear-gradient(135deg, #0a0f1c 0%, #1a2332 50%, #0a0f1c 100%);
  color: #fff;
}

.region-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 215, 0, 0.2);
  border-radius: 15px;
  overflow: hidden;
  margin-bottom: 30px;
  transition: all 0.3s ease;
}

.region-card:hover {
  transform: translateY(-5px);
  border-color: rgba(255, 215, 0, 0.4);
  box-shadow: 0 15px 40px rgba(255, 215, 0, 0.1);
}

.region-image {
  height: 200px;
  overflow: hidden;
}

.region-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.region-card:hover .region-image img {
  transform: scale(1.05);
}

.region-content {
  padding: 30px;
}

.region-content h3 {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
  font-family: 'Archivo', sans-serif;
}

.region-content p {
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 20px;
  line-height: 1.6;
}

.region-features {
  list-style: none;
  padding: 0;
  margin: 0;
}

.region-features li {
  color: #F6EC4F;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.region-features li i {
  font-size: 12px;
}

/* Service Centers */
.service-centers {
  padding: 100px 0;
  background: #00061A;
  color: #fff;
}

.service-type-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(246, 236, 79, 0.2);
  border-radius: 15px;
  padding: 40px;
  margin-bottom: 30px;
  transition: all 0.3s ease;
}

.service-type-card:hover {
  transform: translateY(-5px);
  border-color: rgba(246, 236, 79, 0.4);
  box-shadow: 0 15px 40px rgba(246, 236, 79, 0.1);
}

.service-icon {
  font-size: 48px;
  color: #F6EC4F;
  margin-bottom: 20px;
}

.service-content h3 {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
  font-family: 'Archivo', sans-serif;
}

.service-content p {
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 20px;
  line-height: 1.6;
}

.service-content ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.service-content ul li {
  color: #F6EC4F;
  margin-bottom: 8px;
  padding-left: 20px;
  position: relative;
}

.service-content ul li::before {
  content: '•';
  position: absolute;
  left: 0;
  color: #F6EC4F;
}

/* Partnership Network */
.partnership-network {
  padding: 100px 0;
  background: linear-gradient(135deg, #0a0f1c 0%, #1a2332 50%, #0a0f1c 100%);
  color: #fff;
}

.partner-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 215, 0, 0.2);
  border-radius: 15px;
  padding: 40px 20px;
  margin-bottom: 30px;
  transition: all 0.3s ease;
}

.partner-card:hover {
  transform: translateY(-5px);
  border-color: rgba(255, 215, 0, 0.4);
  box-shadow: 0 15px 40px rgba(255, 215, 0, 0.1);
}

.partner-icon {
  font-size: 48px;
  color: #F6EC4F;
  margin-bottom: 20px;
}

.partner-card h4 {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
  font-family: 'Archivo', sans-serif;
}

.partner-card p {
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
}

/* Responsive Design */
@media (max-width: 991px) {
  .hero-title h1 {
    font-size: 48px;
  }
  
  .section-header h2 {
    font-size: 36px;
  }
  
  .stat-number {
    font-size: 36px;
  }
}

@media (max-width: 767px) {
  .presence-hero {
    padding: 150px 0 80px;
  }
  
  .hero-title h1 {
    font-size: 36px;
  }
  
  .hero-description p {
    font-size: 16px;
  }
  
  .section-header h2 {
    font-size: 28px;
  }
  
  .section-description {
    font-size: 16px;
  }
  
  .stat-card,
  .service-type-card {
    padding: 30px 20px;
  }
  
  .region-content {
    padding: 20px;
  }
}
</style>
